import { Bug } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

export interface FounderBugReportRow {
  id: string;
  business_id: string | null;
  user_id: string;
  description: string | null;
  screenshot_url: string | null;
  created_at: string;
}

export function FounderBugReportsPanel({ rows }: { rows: FounderBugReportRow[] | undefined }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Bug className="h-5 w-5" /> Bug Reports
        </CardTitle>
        <CardDescription>User-submitted bug reports from across the platform.</CardDescription>
      </CardHeader>
      <CardContent data-testid="founder-bug-reports-panel">
        {rows?.length ? (
          <div className="overflow-x-auto">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Date</TableHead>
                  <TableHead>Description</TableHead>
                  <TableHead>Screenshot</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {rows.map((r) => (
                  <TableRow key={r.id}>
                    <TableCell className="text-sm text-muted-foreground">{new Date(r.created_at).toLocaleString()}</TableCell>
                    <TableCell>{r.description ?? "—"}</TableCell>
                    <TableCell>
                      {r.screenshot_url ? (
                        <a href={r.screenshot_url} target="_blank" rel="noreferrer noopener" className="text-primary hover:underline">
                          View
                        </a>
                      ) : (
                        "—"
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        ) : (
          <p className="text-sm text-muted-foreground">No bug reports yet</p>
        )}
      </CardContent>
    </Card>
  );
}
